import React from 'react'
import { Card } from 'plume-ui'
import { LeadingVCCompany } from '../../../types'
import { CardInnerTitle } from '../../atoms/CardInnerTitle'
import { Table, TableHeading, TableCell } from '../../atoms/Table'
import { A } from '../../atoms/A'
import { EmptyCard } from '../../common/EmptyCard'
import { INDUSTRY } from '@/lib/dict'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  list: LeadingVCCompany[]
  className?: string
}

export const LeadingVCCompanyList: React.FC<Props> = (props) => {
  return (
    <Card className={props.className}>
      <CardInnerTitle title="IPO時のリード（トップ）VC一覧" />
      {props.list.length > 0 ? (
        <Table>
          <thead>
            <tr>
              <TableHeading>スタートアップ</TableHeading>
              <TableHeading>IPO年月日</TableHeading>
              <TableHeading>証券コード</TableHeading>
              <TableHeading>IPO市場</TableHeading>
              <TableHeading>東証33業種</TableHeading>
              <TableHeading>業種</TableHeading>
              <TableHeading>シェア</TableHeading>
            </tr>
          </thead>
          <tbody>
            {props.list.map((c, i) => (
              <tr key={i}>
                <TableCell>
                  <A href={c.path} decoration="none" target="_blank">
                    {c.name}
                  </A>
                </TableCell>
                <TableCell>
                  <FormattedDate>{c.ipoDate}</FormattedDate>
                </TableCell>
                <TableCell>{c.stockCode}</TableCell>
                <TableCell>{c.market}</TableCell>
                <TableCell>{c.industry}</TableCell>
                <TableCell>{INDUSTRY[c.jvrIndustry]}</TableCell>
                <TableCell>{c.leadVcShare} %</TableCell>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <EmptyCard />
      )}
    </Card>
  )
}
